import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function MarqueeStrip() {
    const [paused, setPaused] = useState(false);
    const navigate = useNavigate();

    const items = [
        { label: "B.Com / M.Com", targetCats: ["B.Com, M.Com, LL.B., MBA"] },
        { label: "LL.B.", targetCats: ["B.Com, M.Com, LL.B., MBA", "Students - LL.B., MBA, etc"] },
        { label: "MBA", targetCats: ["B.Com, M.Com, LL.B., MBA", "Students - LL.B., MBA, etc"] },
        { label: "CA Inter / CPT", targetCats: ["CA Inter/CPT, CS Exec, CMA Inter"] },
        { label: "CS Executive", targetCats: ["CA Inter/CPT, CS Exec, CMA Inter"] },
        { label: "CMA Inter", targetCats: ["CA Inter/CPT, CS Exec, CMA Inter"] },
        { label: "CA Final", targetCats: ["CA,CS, CMA Final"] },
        { label: "CS Final", targetCats: ["CA,CS, CMA Final"] },
        { label: "CMA Final", targetCats: ["CA,CS, CMA Final"] },
        { label: "Civil & Criminal Laws", targetCats: ["Civil and Criminal laws"] },
        { label: "Corporate & Commercial Laws", targetCats: ["Corporate and Commercial Laws"] },
        { label: "GST & Indirect Tax", targetCats: ["GST, Service Tax & Indirect Tax"] },
        { label: "Income Tax", targetCats: ["Income Tax"] },
        { label: "Labour Laws", targetCats: ["Labour Laws"] },
        { label: "Banking & Finance", targetCats: ["Banking and Finance"] },
    ];

    const doubled = [...items, ...items];

    const handleClick = (item) => {
        setPaused(true);

        const query = item.targetCats
            .map((cat) => `cat=${encodeURIComponent(cat)}`)
            .join("&");

        navigate(`/store?${query}`);
    };

    return (
        <div
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
            style={{
                background: "linear-gradient(90deg, #8B1A1A 0%, #C0392B 50%, #8B1A1A 100%)",
                padding: "12px 0",
                overflow: "hidden",
                position: "relative",
            }}
        >
            <div
                style={{
                    display: "flex",
                    gap: 48,
                    animation: "marquee 28s linear infinite",
                    animationPlayState: paused ? "paused" : "running",
                    width: "max-content",
                }}
            >
                {doubled.map((item, index) => (
                    <span
                        key={`${item.label}-${index}`}
                        onClick={() => handleClick(item)}
                        style={{
                            cursor: "pointer",
                            color: "rgba(255,255,255,0.9)",
                            fontSize: 13,
                            fontWeight: 700,
                            whiteSpace: "nowrap",
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                        }}
                    >
                        {item.label}
                        <span style={{ fontSize: 8 }}>◆</span>
                    </span>
                ))}
            </div>
        </div>
    );
}
